import {Pipe, PipeTransform} from "@angular/core";
import {OPTIMIZATION_TYPES} from "../_maps/optimization-types";

@Pipe({name: "optimizationType"})
export class OptimizationTypePipe implements PipeTransform {
  transform(type: string): any {
    return type && OPTIMIZATION_TYPES[type];
  }
}
